import axios, { AxiosRequestConfig } from 'axios'
import { defaultsDeep } from 'lodash'
import { decrypt } from 'src/common'
import { getNativeInfo } from './jsbridge'
import { handleV3Response, requestV3Headers } from './v3'

type ResponseData<T> = {
  code: number
  data: T
  msg: string
}

enum ApiVersionPaths {
  v1 = 'v1',
  v2 = 'v2',
  v3 = 'v3',
}

const DEFAULT_HEADERS = {
  method: 'GET',
}
// const EUFY_MEGA = 'eufy_mega'
// const EUFY_SECURITY = 'eufy Security'

const getAppVersionCompatibility = async () => {
  const nativeInfo = await getNativeInfo().catch(() =>
    Promise.resolve(undefined)
  )
  console.log('nativeInfo=>>>', nativeInfo)
  if (!nativeInfo || !nativeInfo.appVersion || !nativeInfo.appName) {
    return ApiVersionPaths.v1
  }
  const appVersion = nativeInfo.appVersion.match(/[\d.]+/)?.join('') || ''
  if (/eufy\ssecurity/i.test(nativeInfo.appName)) {
    if (appVersion >= '4.5.1' && appVersion < '4.8.0') {
      return ApiVersionPaths.v2
    } else if (appVersion >= '4.8.0') {
      return ApiVersionPaths.v3
    }
  }
  return ApiVersionPaths.v1
}

// start_ai_generated
function determineApiVersionFromUrl(url: string) {
  const versionPattern = /\/(v\d+)\//
  const match = url.match(versionPattern)
  return match ? (match[1] as ApiVersionPaths) : ApiVersionPaths.v1
}
// end_ai_generated

function getDefaultDomain() {
  const subdomain =
    process.env.GATSBY_DEPLOY_ENV === 'pr' ? 'security-app' : 'security-app-qa'

  return `${subdomain}.eufylife.com`
}

const getBaseURL = async () => {
  if (process.env.NODE_ENV === 'development') return '/api'
  let domain = getDefaultDomain()
  try {
    const info = await getNativeInfo()
    if (info.domain) {
      domain = info.domain
    }
  } catch {
    // 没有 jsbridge 接口
  }

  return domain.replace(/^(?!https:\/\/)/, 'https://')
}

const client = axios.create({
  // withCredentials: true,
  headers: DEFAULT_HEADERS,
})

client.interceptors.response.use(resp => resp.data)

export default function request<T extends unknown>(
  config: AxiosRequestConfig
): Promise<ResponseData<T>>

export default async function request<T extends unknown>(
  url: string | AxiosRequestConfig,
  config?: AxiosRequestConfig
): Promise<ResponseData<T>> {
  const { token, gtoken, appName } = await getNativeInfo()
  // console.log('appName', appName)
  // const token= '813d72faa120c890d64f7c1f0c4adce5a19fcf5b75a8d6c8'
  // const gtoken= 'a173d4405e59fa4c761178fc9ed9fe00'
  // const appName= 'eufy_mega'
  const version = await getAppVersionCompatibility()

  if (typeof url === 'string') {
    url = url.replace(/\/v2\//, `/${version}/`)
    const currVersion = determineApiVersionFromUrl(url)
    console.log(url)
    if (currVersion === ApiVersionPaths.v3) {
      // if (appName === EUFY_MEGA) {
      //   config.headers = {
      //     ...config.headers,
      //     'X-Encryption-Info': 'algo_ecdh',
      //   }
      // } else {
      const { v3_headers, config: newConfig } = await requestV3Headers(config)
      const _headers = config.headers
      config.headers = {
        ..._headers,
        ...v3_headers,
      }
      config.data = newConfig.data
      // }
    }

    return client
      .request({
        ...config,
        headers: defaultsDeep(
          config.headers || {},
          {
            'X-Auth-Token': token,
            'Model-type': 'PHONE',
            'app-name': appName,
            Gtoken: gtoken || '',
          },
          DEFAULT_HEADERS
        ),
        url,
      })
      .then(async res => {
        if (typeof res.data === 'string') {
          if (currVersion === ApiVersionPaths.v3) {
            const data = await handleV3Response(res)
            res.data = data
            console.log('v3 decrypt ===', data)
          }
          if (currVersion === ApiVersionPaths.v2) {
            const data = await decrypt({ type: 0, data: res.data })
            res.data = data
            console.log('v2 decrypt ===', data)
          }
        }
        return res as any
      })
  }

  url.url = url.url.replace(/\/v2\//, `/${version}/`)
  const currVersion = determineApiVersionFromUrl(url.url)
  if (currVersion === ApiVersionPaths.v3) {
    // if (appName === EUFY_MEGA) {
    //   config.headers = {
    //     ...config.headers,
    //     'X-Encryption-Info': 'algo_ecdh',
    //   }
    // } else {
    const { v3_headers, config: newConfig } = await requestV3Headers(url)
    const _headers = url.headers
    url.headers = {
      ..._headers,
      ...v3_headers,
    }
    url.data = newConfig.data
    // }
  }
  return client
    .request({
      ...url,
      baseURL: await getBaseURL(),
      headers: defaultsDeep(
        url.headers || {},
        {
          'X-Auth-Token': token,
          'Model-type': 'PHONE',
          'App-Name': appName,
          Gtoken: gtoken || '',
        },
        DEFAULT_HEADERS
      ),
    })
    .then(async res => {
      if (typeof res.data === 'string') {
        if (currVersion === ApiVersionPaths.v3) {
          const data = await handleV3Response(res)
          res.data = data
          console.log('v3 decrypt ===', data)
        }
        if (currVersion === ApiVersionPaths.v2) {
          const data = await decrypt({ type: 0, data: res.data })
          res.data = data
          console.log('v2 decrypt ===', data)
        }
      }
      return res as any
    })
}
